import BreadcrumbsPath from "./breadcrumbsPathEntity";
import LinkItem from "./linkItemEntity";

export default class CompetencesPage {
    public id: string;
    public title: string;
    public heroImage: string;
    public content: string;
    public plannerLinkList: LinkItem[];
    public supervisorLinkList: LinkItem[];
    public linkItems: LinkItem[];
    public breadcrumbsPath: BreadcrumbsPath;
    
    constructor() {
      this.id = "";
      this.title = "";
      this.heroImage = "";
      this.content = "";

      this.linkItems = [];
      this.plannerLinkList = [];
      this.supervisorLinkList = [];

      this.breadcrumbsPath = new BreadcrumbsPath();
    }
  }


// WEBPACK FOOTER //
// ./src/api/competencesPageEntity.ts